import styled from "styled-components";

export const MyAccount = styled.div`
  font: normal normal normal 16px Montserrat;
`;
export default MyAccount;
